/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('MemberPaymentController', MemberPaymentController);

    MemberPaymentController.$inject = ['PrincipalProfile', '$http', 'AlertService', '$translate', '$state'];

    function MemberPaymentController (PrincipalProfile, $http, AlertService, $translate, $state) {

        var vm = this;

        vm.profile = null;
        vm.ibanInput = null;
        vm.bicInput = null;
        vm.save = save;

        PrincipalProfile.identity(true).then(function(profile) {
            vm.profile = profile;
        });

        vm.truncateBancAccountHolder = function() {
            vm.profile.bankAccountHolder = null;
        };

        function save () {
            vm.isSaving = true;
            if(vm.profile.isUsingSepa === true) {
                if(vm.profile.isDeviatedHolder === false) {
                    vm.profile.bankAccountHolder = vm.profile.user.firstName + ' ' + vm.profile.user.lastName;
                }
            }
            var bancaccount = {
                id: vm.profile.user.id,
                bankAccountHolder: vm.profile.bankAccountHolder,
                iban: vm.ibanInput,
                bic: vm.bicInput,
                isDeviatedHolder: vm.profile.isDeviatedHolder,
                isUsingSepa: vm.profile.isUsingSepa
            };
            $http.post('api/member/bancaccount/', bancaccount).then(function(response) {
                vm.error = null;
                vm.isSaving = false;
                $state.reload();
                AlertService.success($translate.instant('global.messages.update.alert'));
            }, function(error) {
                vm.isSaving = false;
                vm.error = 'ERROR';
                if (error.status === 400 && error.data === 'bic') {
                    AlertService.error('global.messages.error.bic');
                }
                if (error.status === 400 && error.data === 'iban') {
                    AlertService.error('global.messages.error.iban');
                }
            });
        }
    }
})();
